export default __webpack_public_path__ + "static/media/010_home.first.294805ed.png";